import React, { useEffect, useState } from "react";
import Dashboard from "./Dashboard";
import { useGetDashboardGoalsQuery, useGetFinanceSummaryQuery, useGetAllFinanceSummaryQuery } from "src/services/DashboardService";
import moment from "moment";
import { useGetPendingFollowupCountQuery } from "src/services/FollowUpServices";
import { useGetAllBatcheAndStudentCountQuery } from "src/services/BatchServices";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
type Props = {};

const DashboardWrapper = (props: Props) => {

  const {
    dateFilter,
    quarterYear,
    quarter,
  } = useSelector((state: RootState) => state.dashboard);

  const [startDate, setStartDate] = useState(null);
  const [financeData, setFinanceData] = useState({});
  const [profitLossReportData, setProfitLossReportData] = useState<any>()

  const [batchData, setBatchData] = useState<any>();
  const [goalsData, setGoalsData] = useState<any>([])
  const {
    data: pendingCount,
    isLoading: pendingCountIsLoading,
    isFetching: pendingCountIsFetching,
  } = useGetPendingFollowupCountQuery("");

  const { isLoading, isFetching, data } = useGetFinanceSummaryQuery({
    dateFilter: {
      startDate:
        startDate === null
          ? moment().startOf("month").format("YYYY-MM-DD")
          : moment(startDate).format("YYYY-MM-DD"),
      endDate:
        startDate === null
          ? moment().endOf("month").format("YYYY-MM-DD")
          : moment(startDate).endOf("month").format("YYYY-MM-DD"),
    },
  });
  const {
    data: totalCount,
    isLoading: totalCountIsLoading,
    isFetching: totalCountIsFetching,
  } = useGetAllBatcheAndStudentCountQuery('');

  const { data: goalDadhboardData } = useGetDashboardGoalsQuery({
  });

  useEffect(() => {
    if (!totalCountIsFetching && !totalCountIsLoading) {
      setBatchData(totalCount);
    }
  }, [totalCountIsFetching, totalCountIsLoading, totalCount]);

  useEffect(() => {
    if (!isLoading || !isFetching) {
      setFinanceData(data);
    }
  }, [isLoading, isFetching, data]);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setGoalsData(goalDadhboardData?.data)
    }
  }, [isLoading, isFetching, goalDadhboardData])

  // QUARY Profit Loss

  const { data: financeSummaryData, isLoading: isFinanceIsLoading, isFetching: iseFinanceIsFetching } = useGetAllFinanceSummaryQuery({
    dateFilter: {
      startDate: dateFilter.startDate
        ? moment(dateFilter?.startDate).format("YYYY-MM-DD")
        : '',
      endDate: dateFilter.endDate
        ? moment(dateFilter?.endDate).format("YYYY-MM-DD")
        : dateFilter.startDate ? moment().format("YYYY-MM-DD") : '',
    },
    quarters: quarter?.map((el: any) => el?.value) || [],
    year: quarterYear ? moment(quarterYear).format("YYYY") : ''
  });

  // USE EFFECT PROFIT LOSS QUERY
  useEffect(() => {
    if (!isFinanceIsLoading && !iseFinanceIsFetching) {
      setProfitLossReportData(financeSummaryData?.result);
    }
  }, [financeSummaryData, isFinanceIsLoading, iseFinanceIsFetching]);

  return (
    <>
      <Dashboard
        isLoading={isLoading || isLoading || pendingCountIsLoading || pendingCountIsFetching}
        dashboarGoaldData={goalsData}
        goalsLoading={isLoading}
        goalsIsFetching={isFetching}
        batchData={batchData}
        startDate={startDate}
        setStartDate={setStartDate}
        financeData={financeData}
        totalPendingCount={pendingCount?.totalCount}
        profitLossReportData={profitLossReportData}
      />
    </>
  );
};

export default DashboardWrapper;
